import React from "react";
import { useParams } from "react-router-dom";
import { ModuleDetail } from "../../../../components/monitoring/ModuleDetail";

const ModuleDetails = () => {
  const { moduleId } = useParams();

  return <ModuleDetail moduleId={moduleId} />;
};

export default ModuleDetails;
